module.exports = __webpack_public_path__ + "img/project-bg-3.27b4b402.png";